// extracted by mini-css-extract-plugin
export default {"link":"Reports_link__30Ya+"};